import { tv } from "tailwind-variants";

export const popoverContent = tv({
  base: "w-[30rem] right-0",
});
